import './LegalPages.css'

export function PrivacyNotice() {
  return (
    <main className="legal-page">
      <article className="legal-content">
        <header className="legal-header">
          <h1>Clnicl Privacy Notice</h1>
          <p className="legal-meta">Version 1.0 | Effective date: 2026-02-23</p>
        </header>

        <p className="legal-warning">
          Draft for solicitor and DPO review. This notice is a practical draft and not legal advice.
        </p>

        <section className="legal-section">
          <h2>1. Purpose</h2>
          <p>
            This notice describes how personal data is handled when a practice or clinic registers and uses
            Clnicl services, including PPT and PMS workflows.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Roles and Responsibilities</h2>
          <p>
            For patient and staff data entered by the customer, the practice or clinic is generally the data
            controller. Clnicl typically acts as a processor providing hosted software and support services,
            subject to contractual terms and final legal structure.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Data Categories</h2>
          <ul>
            <li>Registration and account data (clinic and contact information)</li>
            <li>Operational user data (login, access, configuration settings)</li>
            <li>Patient and clinical data processed by the customer within the platform</li>
            <li>Security and audit data (access logs, change activity, diagnostics)</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Lawful Basis and Customer Obligations</h2>
          <p>
            The customer is responsible for identifying and documenting lawful basis for processing, handling
            transparency notices, and responding to data subject rights requests where the customer is
            controller.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Security and Retention</h2>
          <p>
            Clnicl uses technical and organisational measures to protect data. Retention periods and deletion
            controls are determined by product settings and contractual obligations, with customer oversight
            for legal and regulatory retention requirements.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. International Transfers and Sub-processors</h2>
          <p>
            Where data transfers occur, appropriate safeguards are to be applied in line with applicable data
            protection law. A formal sub-processor and transfer schedule should be maintained in commercial
            documentation.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Contact and Complaints</h2>
          <p>
            Customers should contact their own data protection lead for controller-side obligations. Clnicl
            privacy contact details and supervisory authority information must be inserted after legal review.
          </p>
        </section>

        <nav className="legal-nav" aria-label="Legal navigation">
          <a href="/terms-and-conditions">Terms and Conditions</a>
          <a href="/pcrs-responsibility">PCRS Responsibility Statement</a>
          <a href="/register">Back to registration</a>
        </nav>
      </article>
    </main>
  )
}
